export class AddVersionWithPathRequest {
    VersionNumber: string;
    Name: string;
    FilePath: string;
    Description: string;
    IsMinorUpdate: boolean;
    Postponable: boolean;
    MinimumLiveHubVersion: number; //A null value will translate to 0 in the backend
    MinimumScoreThreshold: number; //A null or 0 value will translate to 40 in the backend
    RecommendedScoreThreshold?: number; //A null or 0 value will translate to 80 in the backend
    PostponeGroupID?: number;
}
